<template>
  <v-layout column>
    <v-layout row align-center justify-space-between py-3 mb-2>
      <v-layout row align-center justify-start class="face-filter-title">
        <v-icon size="24px">face</v-icon>
        <div class="face-filter-wrapper">
          <div class="face-filter-text">顔認識フィルタ</div>
          <div v-if="showKidTooltip" class="kid-tooltip">
            <v-chip small label color="white" text-color="primary">NEW</v-chip>
            <span class="font-weight-bold">
              お子さまの写真のみに絞り込みます
            </span>
          </div>
        </div>
        <div class="new-feature-badge">新機能</div>
      </v-layout>
      <v-layout align-center justify-end>
        <button
          class="toggle-button"
          :class="{ active: faceDetectedOnly }"
          @click.stop="toggleFaceDetectedOnly"
        >
          <div class="toggle-slider"></div>
        </button>
      </v-layout>
    </v-layout>

    <v-select
      :items="groups"
      item-text="name_with_year"
      item-value="id"
      :value="groupId"
      label="クラス選択"
      no-data-text="選択可能なクラスがありません。"
      outline
      @focus="onSelectFocus"
      @change="$emit('change-group', $event)"
    ></v-select>

    <v-select
      :items="events"
      item-text="eventNameWithCount"
      item-value="id"
      :value="eventId"
      label="イベントを選択してください"
      no-data-text="選択可能なイベントがありません。"
      clearable
      outline
      @focus="onSelectFocus"
      @change="$emit('change-event', $event)"
    ></v-select>
  </v-layout>
</template>

<script>
export default {
  props: {
    groups: {
      type: Array,
      required: true
    },
    groupId: {
      type: Number,
      default: undefined
    },
    events: {
      type: Array,
      required: true
    },
    eventId: {
      type: [Number, String],
      default: undefined
    },
    faceDetectedOnly: {
      type: Boolean,
      default: false
    },
    showKidTooltip: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onSelectFocus() {
      this.$emit("dismiss-face-filter-kid-tooltip");
    },
    toggleFaceDetectedOnly() {
      this.$emit("dismiss-face-filter-kid-tooltip");
      this.$emit("change-face-detected-only", !this.faceDetectedOnly);
    }
  }
};
</script>

<style scoped>
.face-filter-title {
  gap: 8px;
}

.face-filter-text {
  font-size: 16px;
}

.new-feature-badge {
  background-color: #dbe171;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1;
}

.face-filter-wrapper {
  position: relative;
}

.kid-tooltip {
  position: absolute;
  top: 100%;
  left: -45%;
  font-size: 12px;
  margin-top: 4px;
  background-color: #616161;
  color: #fff;
  opacity: 0.8;
  border-radius: 4px;
  padding: 5px 8px;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  /* ツールチップがヘッダーより下に表示されるように */
  z-index: 1;
}

.kid-tooltip::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -98%);
  border-width: 6px;
  border-style: solid;
  border-color: transparent transparent #616161 transparent;
}

.toggle-button {
  background-color: #4cb5b8;
  border: none;
  border-radius: 31px;
  width: 56px;
  height: 32px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s ease;
}

.toggle-button:not(.active) {
  background-color: #ccc;
}

.toggle-slider {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 22px;
  height: 22px;
  background-color: #ffffff;
  border-radius: 16px;
  transition: transform 0.3s ease;
}

.toggle-button.active .toggle-slider {
  transform: translateX(24px);
}

@media (max-width: 768px) {
  .face-filter-text {
    font-size: 14px;
  }
}
</style>
